<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import SearchNormal from '$icons/SearchNormalIcon.svelte'
  import { clickOutside } from '$src/utils/clickOutside.util'
  import Option from '$lib/components/common/inputs/Option.svelte'
  import SimpleCaption from './SimpleCaption.svelte';

  export let selectedValues: {
    icon: string
    title: string
    description: string
    value: string
  }[] = []
  // export let options: {
  // 	icon: string;
  // 	title: string;
  // 	description: string;
  // 	value: string;
  // }[] = [];
  export let label = ''
  export let caption = ''
  export let placeholder = 'Enter here'
  export let danger: boolean = false
  export let dangerMessage: string = ''
  export let focus = false
  export let readonly = false
  export let cursorPointer = false
  export let required: boolean = false

  export let searchValue = ''

  const dispatch = createEventDispatcher()

  $: {
    dispatch('change', { selectedValues, searchValue })
  }

  function handleSubmit() {
    if (searchValue === '') {
      return
    }

    // example
    // selectedValues = [
    // 	...selectedValues,
    // 	{
    // 		icon: null,
    // 		title: searchValue,
    // 		description: '',
    // 		value: searchValue
    // 	}
    // ];

    // searchValue = '';

    dispatch('submit', selectedValues)
  }
</script>

<style type="postcss">
  .input-selected {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.07), 0px 0px 0px 4px #ecefff;
  }
  .input-danger {
    @apply border-[#D75870];
  }
  .input-danger-focus {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.07), 0px 0px 0px 4px #ffecec;
  }
</style>

<div class="flex flex-col items-start gap-2 w-full">
  <label class="text-[#47675B] font-medium text-sm" for="">
    {#if label}{label}{:else}&nbsp;{/if}
    {#if required}
      <span class="text-red-500">*</span>
    {/if}
  </label>
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="relative w-full flex items-center pl-10 min-h-[54px] border
    border-[#D0DDD7] rounded-14 p-4 ease-out duration-100"
    use:clickOutside
    on:keydown
    on:click={() => {
      focus = true
      dispatch('click')
    }}
    on:click_outside={() => {
      focus = false
    }}
    class:input-selected={focus}
    class:input-danger={danger}
    class:input-danger-focus={danger && focus}>
    <div class="absolute left-0 ml-4 cursor-pointer">
      <slot name="icon">
        <SearchNormal />
      </slot>
    </div>
    <div class="overflow-y-auto flex items-center gap-2 w-full">
      {#each selectedValues as value, key}
        <Option
          on:remove-option={() => {
            selectedValues = selectedValues.filter((_, index) => index !== key)
            dispatch('remove-option', selectedValues)
          }}
          option={value} />
      {/each}

      <input
        type="text"
        class="placeholder:text-[#98B3AB] text-[#47675B] bg-transparent
        outline-none w-full min-w-[100px]"
        bind:value={searchValue}
        on:keydown={(event) => {
          if (event.key === 'Enter') {
            handleSubmit()
          } else if (event.key === 'Backspace' && searchValue === '') {
            selectedValues = selectedValues.slice(0, -1)
            dispatch('remove-option', selectedValues)
          }
        }}
        {placeholder}
        {readonly}
        {required}
        class:cursor-pointer={cursorPointer} />
    </div>
  </div>
  <SimpleCaption {danger} {dangerMessage} {caption} />
</div>
